import React from 'react'
import * as styles from './AnimatedScaleOption.module.scss'

import getClassNameFactory from 'util/getClassNameFactory'
import LegacyRetinaImage from 'components/LegacyRetinaImage'

import Check from 'images/inline/spot-the-diff/check.svg'
import Error from 'images/inline/spot-the-diff/error.svg'

const IconMapper = {
  correct: <Check />,
  inCorrect: <Error />,
}

const getClassName = getClassNameFactory('AnimatedScaleOption', styles)
const getCheckboxLabelClassName = getClassNameFactory('CheckboxLabel', styles)
const getIconClassName = getClassNameFactory('AnimatedScaleOptionIcon', styles)

export const AnimatedScaleOption = ({
  index,
  option,
  image,
  optionLabel,
  onChange,
  selected,
  isEditing,
  isLoading,
  className,
  innerWrapperClassName,
  checkClassName,
  labelClassName,
  showRightAnswer,
  correctAnswerId,
  answerId,
  showIcon,
  hasStarted,
}) => {
  const isOnEditingStateAndSelected = selected && isEditing

  const labelOnlyImage = (
    <button
      id={`label-${option}`}
      onClick={isEditing ? e => onChange(index) : null}
      className={
        labelClassName ||
        getCheckboxLabelClassName({
          editing: isEditing,
          withImage: true,
        })
      }
    >
      <LegacyRetinaImage className={getClassName('image')} image={image} />
    </button>
  )

  const labelWithImage = (
    <button
      id={`label-${option}`}
      onClick={isEditing ? e => onChange(index) : null}
      className={
        labelClassName ||
        getCheckboxLabelClassName({
          editing: isEditing,
          withImage: true,
        })
      }
    >
      <div className={getClassName('labelWithImage')}>
        <LegacyRetinaImage className={getClassName('image')} image={image} />
        <div className={getClassName('labelWithImageText')}>
          {optionLabel || option}
        </div>
      </div>
    </button>
  )

  const labelWithoutImage = (
    <button
      id={`label-${option}`}
      onClick={isEditing ? e => onChange(index) : null}
      className={
        labelClassName ||
        getCheckboxLabelClassName({
          editing: isEditing,
          withImage: !!image,
        })
      }
    >
      {optionLabel || option}
    </button>
  )

  const onlyLabel = optionLabel || (option && !image)
  const onlyImage = image && !optionLabel && !option
  const hasLabelAndImage = optionLabel || (option && image)

  return (
    <div
      id={`outer-wrapper-${option}`}
      className={
        className ||
        getClassName({
          isEditing: isOnEditingStateAndSelected,
        })
      }
      key={index}
    >
      <div
        id={`inner-wrapper-${option}`}
        className={getClassName('innerWrapper', innerWrapperClassName)}
      >
        <div
          className={getCheckboxLabelClassName('check', checkClassName)}
          id={option}
        />
        {onlyLabel && labelWithoutImage}
        {onlyImage && labelOnlyImage}
        {hasLabelAndImage && labelWithImage}

        {showIcon && (
          <>
            {!isLoading && showRightAnswer && correctAnswerId === answerId && (
              <div
                className={getIconClassName({
                  iconCorrect: true,
                  iconInImage: hasLabelAndImage || onlyImage,
                })}
              >
                {IconMapper.correct}
              </div>
            )}
            {!isLoading && showRightAnswer && correctAnswerId !== answerId && (
              <div
                className={getIconClassName({
                  iconIncorrect: true,
                  iconInImage: hasLabelAndImage || onlyImage,
                })}
              >
                {IconMapper.inCorrect}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default AnimatedScaleOption
